import React from 'react'
import { Icon } from './CalendarChecked.elements'

type Props = {
  className?: string
}

export const CalendarCheckedIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 96 96"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <g clipPath="url(#clip-calendar-checked)">
      <circle cx="28.138" cy="47.172" r="1.655" fill="#1A1C1F" />
      <circle cx="28.138" cy="58.758" r="1.655" fill="#1A1C1F" />
      <circle cx="28.138" cy="70.344" r="1.655" fill="#1A1C1F" />
      <circle cx="41.379" cy="47.172" r="2.938" stroke="#1A1C1F" strokeWidth="2.4" />
      <circle cx="41.38" cy="58.758" r="1.655" fill="#1A1C1F" />
      <circle cx="41.38" cy="70.344" r="1.655" fill="#1A1C1F" />
      <circle cx="54.621" cy="47.172" r="1.655" fill="#1A1C1F" />
      <circle cx="67.862" cy="47.172" r="1.655" fill="#1A1C1F" />
      <circle cx="54.621" cy="58.758" r="1.655" fill="#1A1C1F" />
      <circle cx="54.621" cy="70.344" r="1.655" fill="#1A1C1F" />
      <circle cx="67.862" cy="58.758" r="1.655" fill="#1A1C1F" />
      <circle cx="67.862" cy="70.344" r="1.655" fill="#1A1C1F" />
      <path d="M73.463 17.17H23.808a7.094 7.094 0 00-7.094 7.093v49.655a7.094 7.094 0 007.094 7.094h49.655a7.094 7.094 0 007.094-7.094V24.263a7.094 7.094 0 00-7.094-7.094zM17.379 38.07h62.896M38.069 30.621h21.517" stroke="#1A1C1F" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M31.448 10.787v12.768M66.207 10.787v12.768" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M31.448 10.786v12.769M66.207 10.786v12.769" stroke="#1A1C1F" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="69.6" cy="69.6" r="19.2" fill="#fff" />
      <path d="M69.6 82.4c7.07 0 12.8-5.73 12.8-12.8s-5.73-12.8-12.8-12.8c-7.069 0-12.8 5.73-12.8 12.8s5.731 12.8 12.8 12.8z" stroke="#05AB5B" strokeWidth="2.4" />
      <path d="M64.267 69.373l3.95 3.95 7.989-7.99" stroke="#05AB5B" strokeWidth="2.4" />
    </g>
    <defs>
      <clipPath id="clip-calendar-checked">
        <path fill="#fff" d="M0 0h96v96H0z" />
      </clipPath>
    </defs>
  </Icon>
)
